import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Chip from '@material-ui/core/Chip';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import logos from './logos';
import translations from './translations';

const App = ({ app, onAdd }) => {
  const handleAdd = () => {
    if (onAdd && typeof onAdd === 'function') {
      onAdd(app);
    }
  };

  return (
    <Grid item xs={12} md={6} lg={4}>
      <Card style={{ height: '100%' }}>
        <Box height="100%" display="flex" flexDirection="column" justifyContent="space-between">
          <Box display="flex">
            <Box pl={1} py={2}>
              <img alt={app.name} src={logos[app?.code] ?? logos.default} width={72} />
            </Box>
            <CardContent style={{ paddingBottom: 0 }}>
              <Typography variant="subtitle1" style={{ fontWeight: 500 }}>
                {app.name}
              </Typography>
              <Typography variant="body2">
                <FormattedMessage
                  {...translations.byAuthor}
                  values={{ author: app.author?.name }}
                />
              </Typography>
              <Box mt={1}>
                <Typography variant="body2" color="textSecondary">
                  {app.description}
                </Typography>
              </Box>
              <Box mt={2}>
                {app.tags?.length > 0 && (
                  <Grid container spacing={1}>
                    {app.tags.map(tag => (
                      <Grid item key={tag}>
                        <Chip label={tag} size="small" />
                      </Grid>
                    ))}
                  </Grid>
                )}
              </Box>
            </CardContent>
          </Box>
          <CardActions>
            <Button color="primary" style={{ marginLeft: 'auto' }} onClick={handleAdd}>
              <FormattedMessage {...translations.actions.add} />
            </Button>
          </CardActions>
        </Box>
      </Card>
    </Grid>
  );
};

App.propTypes = {
  app: PropTypes.object.isRequired,
  onAdd: PropTypes.func,
};

App.defaultProps = {
  onAdd: undefined,
};

export default App;
